import { setStatic } from './setStatic';
export const setDisplayName = (displayName) => setStatic('displayName', displayName);
